import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BREADCRUMBS } from 'config';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { StepIndicatorModel, StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';
import { STEPINDICATORS } from 'config';
import { MobilePivotModel} from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';

@Component({
  selector: 'app-bulk-users',
  providers: [StepIndicatorService],
  templateUrl: './bulk-users.component.html',
  styleUrls: ['./bulk-users.component.scss']
})
export class BulkUsersComponent implements OnInit {

  breadCrumbs: BreadCrumbModel[];
  steps: StepIndicatorModel[];
  stepSessionName: string;
  singleBreadCrumb: BreadCrumbModel;
  pivots: Array<MobilePivotModel>;


  constructor(private router: Router,
    private activatedRoute: ActivatedRoute, private stepIndicatorService: StepIndicatorService,
    private breadCrumbService: BreadCrumbService) {
    this.singleBreadCrumb = new BreadCrumbModel();
    this.stepSessionName = 'bulkUsers';
    this.pivots = new Array<MobilePivotModel>();
  }

  ngOnInit() {
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Add multiple users', routerLink: '/bulkUsers/bulk-action' });
    this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });
    document.title = 'AT&T Business Console - Add multiple users';
    this.steps = STEPINDICATORS.bulkUsers.slice();

    if (this.stepIndicatorService.getSteps(this.stepSessionName) === null) {
      this.stepIndicatorService.setSteps(this.steps, this.stepSessionName);
    }
    this.steps = this.stepIndicatorService.getSteps(this.stepSessionName);

  }
}
